<!--  -->
<template>
  <div class="main-wrap ql-editor">
    <Navigator :routeList="navigate" />
    <main>
      <div class="main-content">
        <div class="title">{{ title }}</div>
        <div class="time">活动时间：{{ time }}</div>
        <div class="content" v-html="code"></div>
      </div>
    </main>
  </div>
</template>

<script>
import Navigator from "@/components/navigate.vue";
export default {
  name: "advertisementViewer",
  components: { Navigator },
  data() {
    return {
      navigate: [
        { name: "首页", url: "/course" },
        { name: "宣传详情", isCurrent: true },
      ],
      title: null,
      code: null,
      time: null,
    };
  },
  mounted() {
    const adObj = JSON.parse(sessionStorage.getItem("adObj"));
    this.title = adObj.name;
    this.code = adObj.adText;
    this.time = adObj.startTime + " — " + adObj.endTime;
  },
};
</script>
<style lang='scss' scoped>
.main-wrap {
  width: 100%;
  height: 100%;
  //补足父元素padding带来的影响
  position: relative;
  bottom: 2rem;
  height: calc(100% + 4rem);
  margin-bottom: -4rem;
  right: 8rem;
  width: calc(100% + 16rem);
  padding: 3rem 8rem;
  box-sizing: border-box;
  background: #fff;
  main {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    .main-content {
      box-sizing: border-box;
      width: 80%;
      min-height: 100rem;
      padding: 5rem 0;
      .title {
        font-size: 3rem;
        color: #000000;
        font-weight: 700;
        margin-bottom: 1.4rem;
      }
      .time {
        font-size: 2rem;
        color: #666666;
        margin-bottom: 4rem;
      }
      // .content {
      //   font-size: 2rem;
      //   ::v-deep p {
      //     line-height: 4rem;
      //   }
      //   ::v-deep img {
      //     display: block;
      //     margin: 1rem auto;
      //     max-width: 100%;
      //   }
      // }
    }
  }
}

@media screen and (min-width: 1680px) {
  .main_wrap {
    padding: 0 16rem;
  }
}
</style>